/* eslint-disable */
import React from 'react';
import {
    BaseFilter,
    ShowTitleByDescription,
    validateStaticDataWithCode,
} from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,

} from 'react-admin';
import { SwList } from '../lib/SwList';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';
import { Typography, Box } from '@mui/material';
var titleStyle = { color: "#AE223F" }
export const ASCcodeLabels = {
    Title: 'ASC code',
    description: 'ASC Subject description',
    pageTitle: 'ASC Codes',
};

export const AscCodeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ASCcodeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label={ASCcodeLabels.Title} source="Title" />
                    <TextField
                        label={ASCcodeLabels.description}
                        source="description"
                    />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const AscCodeCreate = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Create {...props} redirect="edit">
                <SimpleForm validate={validateStaticDataWithCode}>
                    <TextInput label={ASCcodeLabels.Title} source="Title" />
                    <TextInput
                        label={ASCcodeLabels.description}
                        source="description"
                    />
                    <BooleanInput source="current" />
                </SimpleForm>
            </Create>
        </ReadOnlyContext.Provider>
    );
};

export const AscCodeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByDescription />} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <Box display="flex" width={1}>  {/* sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px' }}> */}
                        <Box flex={1}>
                            <Typography variant="h6" style={titleStyle} >
                                <TextField source="id" label={false} />
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput label={ASCcodeLabels.Title} source="Title" fullWidth />
                        </Box>
                        <Box flex={3} ml="0.5em">
                            <TextInput
                                label={ASCcodeLabels.description}
                                source="description"
                                fullWidth

                            />
                        </Box>
                        <Box flex={1} ml="0.5em">
                            <BooleanInput source="current" fullWidth />
                        </Box>
                    </Box>
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <TextInput source="created_at" disabled />
                            <TextInput source="updated_at" disabled sx={{ marginLeft: '0.5em' }} />
                        </Box>
                    </Box>
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const AscCodeShow = (props) => (
    <Show {...props} title={<ShowTitleByDescription />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={ASCcodeLabels.Title} source="Title" />
            <TextField label={ASCcodeLabels.description} source="description" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
